// React Hooks:
import React, { useEffect } from "react";
// React-Router-Dom:
import { useNavigate } from "react-router-dom";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
// Redux Toolkit Actions & State:
import { delayAction, authentication } from "../authenticationSlice";
// MUI Components:
import { Container, Box, Grid, SvgIcon, useTheme } from "@mui/material";
// Components:
import LoginForm from "./login-form/LoginForm";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// Logo Icon:
import { ReactComponent as LogoIcon } from "../../../assets/icons/megaDL-icon.svg";

const useStyles = makeStyles((theme) => ({
  "@keyframes blobAnimation": {
    "0%": {
      borderRadius: "60% 40% 28% 60% / 50% 20% 20% 50%",
    },
    "40%": {
      borderRadius: "90% 40% 20% 81% / 80% 30% 20% 55%",
    },
    "75%": {
      borderRadius: "65% 50% 25% 55% / 60% 20% 20% 65%",
    },
    "100%": {
      borderRadius: "60% 40% 28% 60% / 50% 20% 20% 50%",
    },
  },
  container: {
    height: "100vh",
    width: "100vw",
    color: "#fff",
  },
  blob: {
    position: "fixed",
    left: "40%",
    bottom: "-20%",
    zIndex: -1,
    height: "1400px",
    width: "1500px",
    backgroundColor: theme.palette.primary.light,
    animation: "$blobAnimation 15s infinite",
    [theme.breakpoints.down("lg")]: {
      left: "30%",
    },
    [theme.breakpoints.down("md")]: {
      left: "20%",
    },
    [theme.breakpoints.down("sm")]: {
      left: "-15%",
      bottom: "-30%",
    },
    [theme.breakpoints.down(460)]: {
      left: "-25%",
    },
  },
}));

export const Login = () => {
  const classes = useStyles();

  const theme = useTheme();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const {
    token,
    rule,
    username,
    alert: { delay },
  } = useAppSelector(authentication);

  useEffect(() => {
    if (!!token && !!username && !!rule && delay === true) {
      setTimeout(() => {
        navigate("/");
        dispatch(delayAction(false));
      }, 1200);
    } else if (!!token && delay === false) {
      navigate("/");
    }
  }, [navigate, token, rule, username, delay, dispatch]);

  return (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: { xs: 2 },
      }}
      className={classes.container}
    >
      <Box className={classes.blob} />
      <Grid
        container
        sx={{
          width: "80%",
          minHeight: "80%",
          overflowY: "auto",
          padding: "24px",
          backgroundColor: "transparent",
          borderRadius: "8px",
          boxShadow:
            "5px 5px 10px 0px rgb(0 0 0 / 20%), -2px 3px 10px 0px rgb(0 0 0 / 15%), 0px -2px 10px 0px rgb(0 0 0 / 15%)",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            height: "15%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <SvgIcon
            component={LogoIcon}
            inheritViewBox
            sx={{
              width: "140px",
              height: "auto",
              color: "#F5F5F5",
              [theme.breakpoints.down("md")]: {
                width: "120px",
              },
              [theme.breakpoints.down("sm")]: {
                width: "110px",
              },
              [theme.breakpoints.down(420)]: {
                width: "auto",
                height: "27px",
              },
            }}
          />

          {/* <Link
            to={"/sign-up"}
            style={{ color: theme.palette.text.primary, fontSize: "18px" }}
          >
            Sign Up
          </Link> */}
        </Grid>

        <Grid item xs={12} sx={{ height: "85%" }}>
          <LoginForm />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Login;
